<template>
  <div class="menu">
    <Nav/>
    <div class="header-profile header-profile-mob" v-if="$parent.isAuth">
      <a @click.prevent="$parent.openTopUpModal()" class="button cart topup-balance">
        <img class="img" src="./../images/top_up.svg"/>
        <div v-if="$parent.cartContents && $parent.cartContents.length">
          RO {{ $parent.userBalance }}
        </div>
      </a>
      <router-link class="profile-desc" to="/profile/my-orders">
        <div class="icon">
          <img class="img" src="./../images/user.svg"/>
        </div>
      </router-link>
    </div>
    <div v-else>
      <a class="desc link" @click="$emit('openSignInModal')">
        <b>{{ $t('SIGN IN') }}</b>
        <img src="./../images/link.svg" class="img"/>
      </a>
    </div>
    <div class="select-container cart" v-if="curr && ($parent.currencyOptions.length > 1)">
      <select class="select currency-select" v-model="curr"
              @change="selectCurr()"
      >
        <option :value="item" v-for="item in currOptions" :key="item">{{ item }}</option>
      </select>
    </div>
    <div class="select-container language-select-container" v-if="hasMultipleLanguages">
      <Select2
        class="select2 single language-select"
        :options="languages"
        :model-value="currentLanguageId"
        :settings="{ dropdownCssClass: 'language-select-dropdown' }"
        :placeholder="currentLanguageName"
        @select="selectLanguage($event)"
      />
    </div>
  </div>
</template>

<script>
import Nav from '../components/Nav.vue'
import Select2 from 'vue3-select2-component'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'Menu',
  props: ['currencyCode', 'currencyValue', 'categories'],
  data: function () {
    return {
      curr: ''
    }
  },
  components: {
    Nav,
    Select2
  },
  computed: {
    ...mapState({
      languages: ({ app: { languages } }) =>
        languages.map(({ id, title: text }) => ({ id, text })),
      currentLanguage: (state) => state.app.currentLanguage,
    }),
    ...mapGetters('app', ['currentLanguageName']),
    hasMultipleLanguages() {
      return this.languages.length > 1;
    },
    currentLanguageId() {
      return this.currentLanguage == null ? '' : String(this.currentLanguage);
    },
    currOptions() {
      return this.$parent.currencyOptions.map(({code}) => code);
    }
  },
  watch: {
    currencyCode: function (newValue) {
      this.curr = newValue
    }
  },
  mounted() {
    this.curr = this.currencyCode
  },
  methods: {
    openSignInModal() {
      this.$emit('openSignInModal')
    },
    openSignUpModal() {
      this.$emit('openSignUpModal')
    },
    scrollToSection(section) {
      this.$parent.closeMenu();
      this.$emit('scrollToSection', section)
    },
    selectCurr() {
      this.changeCurrency(this.curr)
      localStorage.setItem("currency", this.curr);
    },
    changeCurrency(item) {
      this.$emit('changeCurrency', item)
    },
    // Select2 emits "select" — its v-model is Vue 3 style and inert under Vue 2.
    selectLanguage(option) {
      if (option && option.id) {
        this.changeLocale(option.id)
      }
    },

    ...mapActions('app', ['changeLocale']),
  },
}
</script>
